import { DetailTranslationKeys, SettingsKeys, TimeTranslationKeys } from '../../api/models/TranslationKeys';
import { Backend } from '../../api/Backend';
import { IPriceResponse3 } from '../../api/models/AndromeTV.types';
import { lngSupportsAdvancedTextRenderer } from './Utility';

function sanitize(content: string) {
  return content.replace(/<[^>]*>/g, '');
}

function formatPrice(backend: Backend, price: number) {
  let decimalCount = backend.globalSettings.numberValue(SettingsKeys.decimalCount);
  decimalCount = decimalCount ? decimalCount : 2;
  let decimalDivider = backend.globalSettings.numberValue(SettingsKeys.decimalDivider);
  decimalDivider = decimalDivider ? decimalDivider : 1;

  if (price === 0) {
    return backend.translations.forKey(DetailTranslationKeys.detail_gratis);
  } else {
    return backend.translations
      .forKey(DetailTranslationKeys.detail_price)
      .replace('$1', (price / decimalDivider).toFixed(decimalCount).toLocaleString());
  }
}

export function formatQualityStringForPriceAndResolution(
  backend: Backend,
  price: IPriceResponse3 | undefined,
  resolution: string,
  validity: number | undefined = undefined
): string {
  let priceString;

  //TODO fix strikethrough of discounted prices
  // note: current solution 'redText => greenText'

  if (price && price.customerPrice && price.originalPrice) {
    if (price.customerPrice === price.originalPrice) {
      priceString = `${sanitize(resolution)}  ${sanitize(formatPrice(backend, price.originalPrice))}`;
    } else {
      if (lngSupportsAdvancedTextRenderer()) {
        priceString = `${sanitize(resolution)}  <color=0xffcc2222>${sanitize(
          formatPrice(backend, price.originalPrice)
        )}</color> => <color=0xff22cc22>${sanitize(formatPrice(backend, price.customerPrice))}</color>`;
      } else {
        priceString = `${sanitize(resolution)}  ${sanitize(formatPrice(backend, price.customerPrice))}`;
      }
    }
  } else {
    priceString = `${sanitize(resolution)}   ${sanitize(formatPrice(backend, 0))}`;
  }

  if (validity) {
    priceString +=
      ' / ' +
      sanitize(backend.translations.forKey(TimeTranslationKeys.time_duration_hours).replace('$1', validity.toString()));
  }
  return priceString;
}
